import React from "react";
import { Outlet, NavLink, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  LayoutDashboard, Package, ShoppingBag, Users, Tag,
  Image as ImageIcon, Mail,
} from "lucide-react";

const items = [
  { to: "/admin", label: "Panel", icon: LayoutDashboard, end: true, testid: "adm-dashboard" },
  { to: "/admin/productos", label: "Productos", icon: Package, testid: "adm-products" },
  { to: "/admin/pedidos", label: "Pedidos", icon: ShoppingBag, testid: "adm-orders" },
  { to: "/admin/clientes", label: "Clientes", icon: Users, testid: "adm-customers" },
  { to: "/admin/cupones", label: "Cupones", icon: Tag, testid: "adm-coupons" },
  { to: "/admin/banners", label: "Banners", icon: ImageIcon, testid: "adm-banners" },
  { to: "/admin/campanas", label: "Campañas", icon: Mail, testid: "adm-campaigns" },
];

export default function AdminLayout() {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12">Cargando…</div>;
  if (!user || user.role !== "admin") return <Navigate to="/login" replace />;

  return (
    <div className="min-h-screen bg-[#F2EFE9]" data-testid="admin-layout">
      <div className="grid grid-cols-12 gap-0">
        <aside className="col-span-12 md:col-span-3 lg:col-span-2 bg-[#2C302E] text-[#F9F6F0] min-h-screen">
          <div className="px-6 py-8 border-b border-white/10">
            <p className="font-serif text-2xl tracking-tighter">Tienda <em className="text-[#D4A373] not-italic">Bonita</em></p>
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4A373] mt-1">Administrador</p>
          </div>
          <nav className="py-4">
            {items.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.end}
                data-testid={it.testid}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-6 py-3 text-sm transition-colors ${isActive ? "bg-[#A94438] text-white" : "hover:bg-white/5"}`
                }
              >
                <it.icon size={16} />
                {it.label}
              </NavLink>
            ))}
          </nav>
          <div className="px-6 py-4 mt-auto text-xs text-white/50">
            <a href="/" className="link-underline">← Volver a la tienda</a>
          </div>
        </aside>
        <main className="col-span-12 md:col-span-9 lg:col-span-10 p-6 md:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
